export default __webpack_public_path__ + "static/covid-abb939413caa6aa6c5f08b1678ab4267.png";